import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function ZapCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    const sourceCard: BaseCard = system.getCardByID(taskData.cards[0]);
    sourceCard.getComponent(Renderable).visible = true;
    sourceCard.score = taskData.cardsScore[0];

    const zapAnimator = GameObject.Instantiate(Animator);

    const targetCards: BaseCard[] = [];
    for (let i = 1; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        card.getComponent(Renderable).visible = true;
        card.score = taskData.cardsScore[i];
        zapAnimator.addChild(card);
        targetCards.push(card);
    }

    system.animator.addChild(zapAnimator);

    system.taskQueue.queueNext(
        new CardAnimationTask(taskData, system, 'CardZap', zapAnimator, {
            sourceCard: sourceCard,
            targetCards: targetCards,
        })
    );
}
